import { generateOneLoginDestinationUrl } from './generateOneLoginDestinationUrl';

const onEnterBankingAccounts =
  ({ getState }) =>
  (nextState, replace, callback) => {
    if (global.BROWSER) {
      let timer;
      const oneLoginUrl = getState().getIn(['config', 'oneLoginUrl']);
      const browserOrigin = getState().getIn(['browser', 'location', 'origin']);
      const redirectUrl = generateOneLoginDestinationUrl(
        oneLoginUrl,
        browserOrigin,
        nextState.location.pathname
      );

      const clearSetTarget = () => {
        if (timer) {
          clearTimeout(timer);
        }
      };

      const setTarget = () => {
        if (window.AmexSession) {
          window.AmexSession.options({
            target: redirectUrl,
          });
          clearSetTarget();
        } else {
          clearSetTarget();
          timer = setTimeout(setTarget, 100);
        }
      };

      setTarget();
    }
    callback();
  };

export default onEnterBankingAccounts;
